module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12X1J5a/tc-custom/Cover.jpg?1684305842568?1714677659367",
      "alt": "This image is the cover for the book Buffy the Vampire Slayer Legacy Edition Book 2, Buffy the Vampire Slayer"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Buffy the Vampire Slayer Legacy Edition Book 2, Buffy the Vampire Slayer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Set during the third season of the Buffy the Vampire Slayer television series, discover the untold stories of the Scoobies during the most dangerous time ever—their final year at Sunnydale High! As if finals and the threat of further education weren’t bad enough, Buffy & her friends will have to fight superpowered vampires and doppelgängers, all at the whim of the terrifying Big Bad Selke! Collects Buffy the Vampire Slayer #11-19 (Dark Horse Comics), as well as short stories from the era, including “Bad Dog,” the first comic work by screenwriter/director and Buffy alum Douglas Petrie.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joss Whedon\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0